import { Component } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { ConnectionStatusService } from 'src/app/services/connection-status.service';
import { combineLatest } from 'rxjs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SessionService } from 'src/app/services/session.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { buildInfo } from '../../../build-info';
import { MatDialog } from '@angular/material/dialog';
import { BuildInfoDialogComponent } from '../build-info-dialog/build-info-dialog.component';

@Component({
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {
  readonly branch = buildInfo.branch;

  connStatus$ = combineLatest({
    netStatus: this.connectionStatusService.networkStatus$,
    offlineMode: this.connectionStatusService.offlineMode$
  })

  isMobile = this.deviceService.isMobile();

  constructor(
    public store: StoreService,
    public sessionService: SessionService,
    public connectionStatusService: ConnectionStatusService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog
  ) {
  }

  logout() {
    this.sessionService.logout();
  }
  toggleOfflineMode(event: MatSlideToggleChange) {
    event.checked ? this.connectionStatusService.goOnline() : this.connectionStatusService.goOffline();
  }

  protected buildInfo() {
    console.log(buildInfo)
    this.dialog.open(BuildInfoDialogComponent, {
      data: {
        feVersion: buildInfo.branch,
        beVersion: this.store.beBuildInfo?.branch
      }
    });
  };
}
